module.exports = __webpack_public_path__ + "staticcomp/img/cover.bcde3bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/5/cover.jpg
// module id = rLyI
// module chunks = 39